const pairs = {
  "Limit": "#FF4848",
  "1,2": "#FB8604",
  "2,1": "#FB8604",
  "3,6": "#008000",
  "6,3": "#008000",
  "4,5": "#0247FE",
  "5,4": "#0247FE",
  "7,8": "#8B4513",
  "8,7": "#8B4513",
  "1,2-3,6": "#FB8604",
  "1,2-6,3": "#FB8604",
  "2,1-3,6": "#FB8604",
  "2,1-6,3": "#FB8604",

  "1,2-4,5": "#FD4D0C",
  "1,2-5,4": "#FD4D0C",
  "2,1-4,5": "#FD4D0C",
  "2,1-5,4": "#FD4D0C",

  "1,2-7,8": "#FCBA12",
  "1,2-8,7": "#FCBA12",
  "2,1-7,8": "#FCBA12",
  "2,1-8,7": "#FCBA12",

  "3,6-1,2": "#008000",
  "3,6-2,1": "#008000",
  "6,3-1,2": "#008000",
  "6,3-2,1": "#008000",

  "3,6-4,5": "#9ACD32",
  "3,6-5,4": "#9ACD32",
  "6,3-4,5": "#9ACD32",
  "6,3-5,4": "#9ACD32",

  "3,6-7,8": "#2EAD85",
  "3,6-8,7": "#2EAD85",
  "6,3-7,8": "#2EAD85",
  "6,3-8,7": "#2EAD85",

  "4,5-3,6": "#0247FE",
  "4,5-6,3": "#0247FE",
  "5,4-6,3": "#0247FE",
  "5,4-3,6": "#0247FE",

  "4,5-7,8": "#347B98",
  "4,5-8,7": "#347B98",
  "5,4-8,7": "#347B98",
  "5,4-7,8": "#347B98",

  "4,5-1,2": "#4424D6",
  "4,5-2,1": "#4424D6",
  "5,4-2,1": "#4424D6",
  "5,4-1,2": "#4424D6",

  "7,8-3,6": "#8B4513",
  "7,8-6,3": "#8B4513",
  "8,7-6,3": "#8B4513",
  "8,7-3,6": "#8B4513",

  "7,8-1,2": "#D2691E",
  "7,8-2,1": "#D2691E",
  "8,7-2,1": "#D2691E",
  "8,7-1,2": "#D2691E",

  "7,8-4,5": "#A52A2A",
  "7,8-5,4": "#A52A2A",
  "8,7-5,4": "#A52A2A",
  "8,7-4,5": "#A52A2A",
}

const pairColor = (pPair) => {
  return pairs[pPair]
}

export {
  pairs,
  pairColor
}



// WEBPACK FOOTER //
// ./src/components/common/results/paircolors/index.js